<template>
	<form class="address-details-form">
		<h5 class="font-weight-bold fixed-height text-nowrap">Billing info</h5>
		<div class="form-row">
			<div class="form-group col">
				<label for="companyName">Company name</label>
				<input
					id="companyName"
					type="text"
					class="form-control"
					placeholder="Company name"
					v-model="address.companyName"
				/>
			</div>
			<div class="form-group col">
				<label for="companyVat">Company VAT</label>
				<input
					id="companyVat"
					type="text"
					class="form-control"
					placeholder="VAT"
					v-model="address.companyVat"
				/>
			</div>
		</div>
		<div class="form-row">
			<div class="form-group col">
				<label for="country">Country</label>
				<select
					id="country"
					type="text"
					class="form-control"
					v-model="address.addressCountry"
				>
					<option v-for="(c, i) in countries" :key="i" :value="c">
						{{ c }}
					</option>
				</select>
			</div>
			<div class="form-group col">
				<label for="city">City</label>
				<input
					id="city"
					type="text"
					class="form-control"
					placeholder="City"
					v-model="address.addressCity"
				/>
			</div>
		</div>
		<div class="form-row">
			<div class="form-group col-4">
				<label for="zip">ZIP code</label>
				<input
					id="zip"
					type="text"
					class="form-control"
					placeholder="ZIP"
					v-model="address.addressZip"
				/>
			</div>
			<div class="form-group col-8">
				<label for="address">Address</label>
				<input
					id="address"
					type="text"
					class="form-control"
					placeholder="Address"
					v-model="address.addressLine1"
				/>
			</div>
		</div>
	</form>
</template>

<script>
import countriesList from "../../assets/geodata/countries.json";
export default {
	name: "AddressForm",
	data() {
		return {
			address: {
				addressZip: "",
				addressCity: "",
				addressLine1: "",
				addressLine2: "",
				addressCountry: "",
				companyName:"",
				companyVat:""
			},
			countries: [],
		};
	},
	mounted() {
		this.countries = Object.keys(countriesList).sort((a, b) => a - b);
	},
	methods: {
		getAddress() {
			return this.address;
		},
	},
};
</script>

<style scoped>
.fixed-height {
	height: 28px;
}
</style>